import React from "react";
import { social } from "../Data";
import Thanks from "./Thanks";
const Contact = () => {
	return (
		<div id="contact">
			<h2>contact me</h2>

			{/* <ul className="social-icons">
				{social.map((item) => {
					return (
						<a href={item.url} target="_blank" key={item.id}>
							<li key={item.id}>{item.icon}</li>
						</a>
					);
				})}
			</ul> */}
			<section className="form">
				<form action="https://formsubmit.co/f4450ac94b7a7f71bbc1a79f40ce3f98" method="POST">
					<h3>Send me a message</h3>
					<div className="info">
						<div className="contactName">
							<input type="text" name="name" placeholder="Name" />
						</div>
						<div className="contactEmail">
							<input type="email" name="email" placeholder="Email"  />
						</div>
						<div className="contactEmail">
							<input type="text" name="subject" placeholder="Subject" />
						</div>
						<div className="contactMSG">
							<textarea name="message" placeholder="Message" ></textarea>
						</div>
						<input type="hidden" name="_next" value="https://ibroport.netlify.app/" />
					</div>
					<button type="submit" className="contactBtn">
						Send
					</button>
				</form>
			</section>
		</div>
	);
};

export default Contact;
